import * as types from './types'

export const getSignableDocuments = (payload: any) => ({
  type: types.GET_SIGNABLE_DOCUMENTS,
  payload,
})

export const editSignableDocument = (payload: any) => ({
  type: types.EDIT_SIGNABLE_DOCUMENT,
  payload,
})

export const removeSignableDocumentsForContract = (payload: {
  contractId: string
  documentTypes: string[]
}) => ({
  type: types.REMOVE_SIGNABLE_DOCUMENTS_FOR_CONTRACT,
  payload,
})

export const getFMMetadatas = (payload: any) => ({
  type: types.GET_FM_METADATAS,
  payload,
})

export const addLockedFMMetadata = (payload: any) => ({
  type: types.ADD_LOCKED_FM_METADATA,
  payload,
})

export const removeLockedFMMetadata = (subTradeId: string) => ({
  type: types.REMOVE_LOCKED_FM_METADATA,
  payload: subTradeId,
})

export const setFMMetadata = (subTradeId: string, data: any) => ({
  type: types.SET_FM_METADATA,
  payload: { subTradeId, data },
})

export const setFMMetadataLoading = (subTradeId: string, isLoading: boolean) => ({
  type: types.SET_FM_METADATA_LOADING,
  payload: { subTradeId, isLoading },
})

export const setFMMetadataError = (subTradeId: string, error: string | null) => ({
  type: types.SET_FM_METADATA_ERROR,
  payload: { subTradeId, error },
})

export const setSignableDocumentsGenerating = (isGenerating: boolean) => ({
  type: types.SET_SIGNABLE_DOCUMENTS_GENERATING,
  payload: isGenerating,
})

// Bumped whenever a document is regenerated. AA Document Metadata is fetched
// per component rather than held in the store, so this is what tells those
// fetches their copy is out of date — without it the "not refreshed" chip and
// Alert flag survive the very regenerate that fixed them, until a page reload.
export const documentsRegenerated = () => ({
  type: types.DOCUMENTS_REGENERATED,
})
